<template lang="pug">
.start-stop-lines-overlay(
  :style="{ gridTemplateColumns: `repeat(${labelCount}, minmax(0, 1fr))` }"
  :class="{ 'start-stop-lines-overlay-standard': !remoteVsOffice }"
)
  .start-stop-line(
    v-for="i in labelCount"
    :key="i"
  )
</template>

<script>
export default {
  name: 'InsightsStartStopTimeLinesOverlay',
  props: {
    labelCount: {
      type: Number,
      required: true,
    },
    remoteVsOffice: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
